<selected-project-list-controller class="flex-none"></selected-project-list-controller>
<div
  class="relative w-full h-full py-4 px-1 flex flex-col justify-center items-center gap-4 rounded bg-gray-100"
>
  <p class="text-gray-800 dark:text-white font-semibold text-sm lg:text-lg">Part Setting</p>
  <div class="relative w-[90%] flex flex-row justify-between items-center">
    <p class="text-gray-800 dark:text-white text-xs lg:text-base">Part Custom Active</p>
    <mat-slide-toggle [(ngModel)]="isPartChange" (ngModelChange)="onChangeIsPart()">
    </mat-slide-toggle>
  </div>
  @if (selectedTemplate) {
    <div class="text-gray-800 relative w-full h-full">
      <mat-tab-group class="text-gray-800 relative w-full h-full">
        @for (partCategory of selectedTemplate.partCategories; track partCategory) {
          <mat-tab class="text-gray-800 relative w-full h-full" [label]="partCategory.title">
            <div class="relative w-full h-full pt-2 px-2 flex flex-col gap-2 overflow-y-auto">
              @for (partModel of partCategory.partModels; track partModel) {
                <button
                  class="relative isolate flex-none flex flex-col justify-end ring-[#0047FF] duration-200 rounded w-full h-28 overflow-hidden disabled:animate-pulse"
                  (click)="onClickPart(partModel)"
                  [ngClass]="{
                    'ring-2': isSelectedPart(partModel),
                    'ring-0': !isSelectedPart(partModel),
                  }"
                  [disabled]="isLoading"
                >
                  <div
                    class="absolute right-2 top-2 flex h-4 w-4 flex-none items-center justify-center rounded-full border duration-200 z-10"
                    [ngClass]="{
                      'bg-[#0047FF] text-white': isSelectedPart(partModel),
                      'bg-none text-white/60': !isSelectedPart(partModel),
                    }"
                  >
                    <svg class="h-2.5 w-2.5" viewBox="0 0 12 10">
                      <polyline
                        fill="none"
                        stroke-width="2px"
                        stroke="currentColor"
                        stroke-dasharray="16px"
                        points="1.5 6 4.5 9 10.5 1"
                      ></polyline>
                    </svg>
                  </div>
                  <img
                    [src]="partModel.thumbnail"
                    alt="University of Southern California"
                    class="absolute inset-0 h-full w-full object-cover"
                  />
                  <div
                    class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"
                  ></div>
                  <h3 class="z-10 mb-2 px-1 text-[0.625rem] font-bold text-white">
                    {{ partModel.title }}
                  </h3>
                </button>
              }
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }
</div>
